import React from "react";
import PropTypes from "prop-types";

class ObjectField extends React.Component {
    static propTypes = {
        name: PropTypes.string,
        object: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        children: PropTypes.func.isRequired,
        dummy: PropTypes.any
    };

    shouldComponentUpdate(nextProps) {
        // dummy field is required for proper rerendering when using inside ArrayField:
        // with the check only for 'object' it wouldn't rerender children when some item in array was removed and
        // therefore 'index' inside children was changed
        //
        // on the other hand, we may not specify dummy, which equals the check only for object - this is convenient
        // when using the component on its own

        return (nextProps.object !== this.props.object || nextProps.dummy !== this.props.dummy)
    }

    onChange = (ev) => {
        const {name, type, checked, value} = ev.target;
        const p = name.lastIndexOf('.');
        this.props.onChange({
            target: {
                name: this.props.name || name.slice(0, p),
                value: {
                    ...this.props.object,
                    [name.slice(p + 1)]: (type === "checkbox" ? checked : value)
                }
            }
        });
    };

    render() {
        // console.log('ObjectField render');
        const props = {onChange: this.onChange, object: this.props.object};
        return this.props.children(props);
    }
}

export default ObjectField;